export const menuItemsData = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About Us",
    url: "/about",
  },
  {
    title: "Modules",
    submenu: [
      {
        title: "Module 1",
        url: "module1",
      },
      {
        title: "Module 2",
        url: "module2",
      },
      {
        title: "Module 3",
        url: "module3",
      },
      {
        title: "Module 4",
        url: "module4",
      },
      {
        title: "Outro",
        url: "outro",
      },
    ],
  },
  {
    title: "Additional Resources",
    url: "/resources",
  },
  {
    title: "Contact Us",
    url: "/contact",
  },
];
